"use client";

import { Play, CheckCircle2, ArrowUpRight, ArrowDownRight, LayoutDashboard, Calendar, Users, Home, Utensils, CreditCard, UserCheck, ShieldAlert, BarChart3, Globe, Settings } from "lucide-react";
import styles from "./Hero.module.css";
import Image from "next/image";

export default function Hero() {
  return (
    <section className={styles.hero} id="hero">
      {/* Background blobs for premium depth */}
      <div className={styles.blurBlob1}></div>
      <div className={styles.blurBlob2}></div>

      <div className={`${styles.container} container`}>
        {/* Left column: Content */}
        <div className={styles.content}>
          <div className={styles.tag}>
            <span className="badge badge-blue">All-in-One Hotel Management Software</span>
          </div>
          
          <h1 className={styles.title}>
            Run Your Hotel. <br />
            Grow Your Business. <br />
            <span className="text-gradient">Launch Your Website.</span>
          </h1>

          <p className={styles.description}>
            Moteligo is the complete hotel management platform that helps you manage bookings, guests, staff, payments, restaurant and more — all from one powerful dashboard.
          </p>

          <div className={styles.ctaGroup}>
            <a href="#demo" className={styles.btnPrimary}>
              Book a Free Demo
            </a>
            <a href="#features" className={styles.btnSecondary}>
              Explore Features
              <span className={styles.playIconWrapper}>
                <Play size={12} fill="currentColor" />
              </span>
            </a>
          </div>

          <div className={styles.featuresList}>
            <div className={styles.featureItem}>
              <CheckCircle2 size={16} className={styles.checkIcon} />
              <span>Cloud Based</span>
            </div>
            <div className={styles.featureItem}>
              <CheckCircle2 size={16} className={styles.checkIcon} />
              <span>Secure & Reliable</span>
            </div>
            <div className={styles.featureItem}>
              <CheckCircle2 size={16} className={styles.checkIcon} />
              <span>Easy to Use</span>
            </div>
            <div className={styles.featureItem}>
              <CheckCircle2 size={16} className={styles.checkIcon} />
              <span>No Installation</span>
            </div>
          </div>
        </div>

        {/* Right column: Website Mockup Image */}
        <div className={styles.visual}>
          <Image 
            src="/images/hero-mockup.png" 
            alt="Moteligo Hotel Website Mockup" 
            width={800} 
            height={600} 
            className={styles.mockupImage} 
            priority
          />
        </div>
      </div>
    </section>
  );
}
